import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../root-redux/RootState";
import { SPA_CAMPAIGN, SPA_CAMPAIGN_LABEL } from "../../feature-components/spa-admin/SPAConstants";

export const getTenantDisplayLabel = (name: string): string => {
    return name === SPA_CAMPAIGN ? SPA_CAMPAIGN_LABEL : name;
};

export const getTenantRawName = (label: string): string => {
    return label === SPA_CAMPAIGN_LABEL ? SPA_CAMPAIGN : label;
};

export const allTeamsSelector = createSelector(( state: RootState) => state.appPersonas.list, (appPersonaItems) => {
    var allTeams : string[] =[];
    appPersonaItems.map((item) => {
        allTeams.push(item.appName)
    });
    return allTeams;
})